import { call, put, takeEvery } from 'redux-saga/effects';
import { handleApiResponse } from '../../utils/functions';
import {
    GET_BOOKING_LIST,
    CREATE_BOOKING,
    UPDATE_BOOKING,
    DELETE_BOOKING,
    GET_BOOKING_BY_ID,
    GET_AVAILABLE_ROOMS,
    CHANGE_ROOM,
    UPGRADE_ROOM,
    GET_BOOKINGS_BY_PATIENT
} from '../storeTypes';
import {
    GetBookingListApi,
    CreateBookingApi,
    UpdateBookingApi,
    DeleteBookingApi,
    GetBookingByIdApi,
    GetAvailableRoomsApi,
    ChangeRoomApi,
    UpgradeRoomApi,
    GetBookingsByPatientApi
} from '../../utils/api';
import {
    ActionGetBookingListSuccess,
    ActionCreateBookingSuccess,
    ActionUpdateBookingSuccess,
    ActionGetBookingByIdSuccess,
    ActionGetAvailableRoomsSuccess,
    ActionGetAvailableRoomsError,
    ActionChangeRoomSuccess,
    ActionChangeRoomError,
    ActionUpgradeRoomSuccess,
    ActionUpgradeRoomError,
    ActionGetBookingsByPatientSuccess
} from '../Actions/BookingAction';

const File = 'BookingSaga';

function* GetBookingListSaga(action) {
    try {
        const response = yield call(GetBookingListApi, action.payload);
        if (response?.status === 200) {
            yield put(ActionGetBookingListSuccess(response?.data?.data || []));
            if (action?.callBack) {
                action?.callBack(response?.data?.data || []);
            }
        }
    } catch (error) {
        handleApiResponse(error?.response?.status, error?.response?.data, action?.callback);
        if (action?.callBack) {
            action?.callBack(null, error);
        }
    }
}

function* CreateBookingSaga(action) {
    try {
        const response = yield call(CreateBookingApi, action.payload);
        if (response?.status === 200) {
            action?.callBack(response?.data);
            yield put(ActionCreateBookingSuccess(response?.data));
        }
    } catch (error) {
        handleApiResponse(error?.response?.status, error?.response?.data, action?.callBack);
    }
}

function* UpdateBookingSaga(action) {
    try {
        const response = yield call(UpdateBookingApi, action.payload);
        if (response?.status === 200) {
            action?.callBack(response?.data);
            yield put(ActionUpdateBookingSuccess(response?.data));
        }
    } catch (error) {
        handleApiResponse(error?.response?.status, error?.response?.data, action?.callBack);
    }
}

function* DeleteBookingSaga(action) {
    try {
        const response = yield call(DeleteBookingApi, action.payload);
        if (response?.status === 200) {
            action?.callBack(200);
        }
    } catch (error) {
        handleApiResponse(error?.response?.status, error?.response?.data, action?.callBack);
    }
}

function* GetBookingByIdSaga(action) {
    try {
        const response = yield call(GetBookingByIdApi, action.payload);
        if (response?.status === 200) {
            yield put(ActionGetBookingByIdSuccess(response?.data?.data || {}));
        }
    } catch (error) {
        handleApiResponse(error?.response?.status, error?.response?.data, action?.callBack);
    }
}

function* GetAvailableRoomsSaga(action) {
    try {
        const response = yield call(GetAvailableRoomsApi, action.payload);
        if (response?.status === 200) {
            yield put(ActionGetAvailableRoomsSuccess(response?.data?.data || []));
            if (action?.callBack) {
                action?.callBack(response?.data?.data || []);
            }
        }
    } catch (error) {
        yield put(ActionGetAvailableRoomsError(error?.response?.data?.message || 'Failed to fetch available rooms'));
        handleApiResponse(error?.response?.status, error?.response?.data, action?.callBack);
        if (action?.callBack) {
            action?.callBack(null, error);
        }
    }
}

function* ChangeRoomSaga(action) {
    try {
        const { bookingId, newRoomId } = action.payload;
        const response = yield call(ChangeRoomApi, bookingId, { newRoomId });
        if (response?.status === 200) {
            yield put(ActionChangeRoomSuccess(response?.data));
            if (action?.callBack) {
                action?.callBack(response?.data);
            }
        }
    } catch (error) {
        yield put(ActionChangeRoomError(error?.response?.data?.message || 'Failed to change room'));
        handleApiResponse(error?.response?.status, error?.response?.data, action?.callBack);
        if (action?.callBack) {
            action?.callBack(null, error);
        }
    }
}

function* UpgradeRoomSaga(action) {
    try {
        const { bookingId, newRoomId, newRoomTypeId, newOccupancyModeId, useMemberDays } = action.payload;
        const response = yield call(UpgradeRoomApi, bookingId, { newRoomId, newRoomTypeId, newOccupancyModeId, useMemberDays });
        if (response?.status === 200) {
            yield put(ActionUpgradeRoomSuccess(response?.data));
            if (action?.callBack) {
                action?.callBack(response?.data);
            }
        }
    } catch (error) {
        yield put(ActionUpgradeRoomError(error?.response?.data?.message || 'Failed to upgrade room'));
        handleApiResponse(error?.response?.status, error?.response?.data, action?.callBack);
        if (action?.callBack) {
            action?.callBack(null, error);
        }
    }
}

function* GetBookingsByPatientSaga(action) {
    try {
        const response = yield call(GetBookingsByPatientApi, action.payload);
        if (response?.status === 200) {
            yield put(ActionGetBookingsByPatientSuccess(response?.data?.data || []));
            if (action?.callBack) {
                action?.callBack(response?.data?.data || []);
            }
        }
    } catch (error) {
        handleApiResponse(error?.response?.status, error?.response?.data, action?.callBack);
        if (action?.callBack) {
            action?.callBack(null, error);
        }
    }
}

export function* BookingSaga() {
    yield takeEvery(GET_BOOKING_LIST, GetBookingListSaga);
    yield takeEvery(CREATE_BOOKING, CreateBookingSaga);
    yield takeEvery(UPDATE_BOOKING, UpdateBookingSaga);
    yield takeEvery(DELETE_BOOKING, DeleteBookingSaga);
    yield takeEvery(GET_BOOKING_BY_ID, GetBookingByIdSaga);
    yield takeEvery(GET_AVAILABLE_ROOMS, GetAvailableRoomsSaga);
    yield takeEvery(CHANGE_ROOM, ChangeRoomSaga);
    yield takeEvery(UPGRADE_ROOM, UpgradeRoomSaga);
    yield takeEvery(GET_BOOKINGS_BY_PATIENT, GetBookingsByPatientSaga);
}
